var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabela-rent-benchmark" }, [
    _c(
      "table",
      { staticClass: "table-new-ux-v1 tabela-dados tabela-retornos text-left" },
      [
        _vm._m(0),
        _c(
          "tbody",
          [
            _vm.temRentabilidade
              ? _c("tr", [
                  _vm._m(1),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.rentabilidadesAll.rentabilidade.mes || "-")
                      )
                    ])
                  ]),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.rentabilidadesAll.rentabilidade.ano || "-")
                      )
                    ])
                  ]),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.rentabilidadesAll.rentabilidade["12M"] || "-"
                        )
                      )
                    ])
                  ]),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.rentabilidadesAll.rentabilidade.data_inicio ||
                            _vm.rentabilidadesAll.data_inicio ||
                            "-"
                        )
                      )
                    ])
                  ]),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.rentabilidadesAll.rentabilidade.inicio || "-"
                        )
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._l(_vm.benchmarksSelecionados, function(benchId) {
              return _c(
                "tr",
                { key: benchId },
                [
                  benchId === _vm.comparisonBenchId
                    ? [
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass: "d-inline-flex align-center",
                              class: {
                                "cb-label": benchId === "cliente_benchmark"
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.comparisonLabel) + " "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", "max-width": "260" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "ml-1 d-inline-flex"
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("icon-svg", {
                                                  attrs: {
                                                    name: "info-circle",
                                                    size: 14
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " Desempenho da carteira em relação ao benchmark de referência do cliente no período. "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesAll.rentabilidade_relativo
                                  .mes || "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesAll.rentabilidade_relativo
                                  .ano || "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesAll.rentabilidade_relativo[
                                  "12M"
                                ] || "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesAll.rentabilidade_relativo
                                  .data_inicio ||
                                  _vm.rentabilidadesAll.data_inicio ||
                                  "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesAll.rentabilidade_relativo
                                  .inicio || "-"
                              ) +
                              " "
                          )
                        ])
                      ]
                    : benchId === "cliente_benchmark" &&
                      _vm.clienteBenchmarkMeta
                    ? [
                        _c("td", [
                          _c("span", { staticClass: "cb-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.clienteBenchmarkMeta.label ||
                                    "Meu Benchmark"
                                ) +
                                " "
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId].mes ||
                                      "-"
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId].ano ||
                                      "-"
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId][
                                      "12M"
                                    ] || "-"
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.rentabilidadesAll.data_inicio || "-") +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId][
                                      "inicio"
                                    ] || "-"
                                  : "-"
                              ) +
                              " "
                          )
                        ])
                      ]
                    : [
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.mapBenchmarks[benchId]) + " ")
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId].mes
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId].ano
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId]["12M"]
                                  : "-"
                              ) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.rentabilidadesAll.data_inicio || "-") +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rentabilidadesBenchmarks[benchId]
                                  ? _vm.rentabilidadesBenchmarks[benchId][
                                      "inicio"
                                    ]
                                  : "-"
                              ) +
                              " "
                          )
                        ])
                      ]
                ],
                2
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "border-bottom-thead" }),
        _c("th", [_vm._v(" Mês ")]),
        _c("th", [_vm._v(" Ano ")]),
        _c("th", [_vm._v(" 12 meses ")]),
        _c("th", [_vm._v(" Data ")]),
        _c("th", [_vm._v(" Início ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Rentabilidade")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }